import { t } from '@moovly/i18n';
import { Select } from '@moovly/ui';
import * as React from 'react';

import ProjectsTable from '../components/ProjectsTable';
import useUserProjects from '../hooks/useUserProjects';

interface UserContainerProps {
  userId: string;
}

const UserContainer: React.FC<UserContainerProps> = ({ userId }) => {
  const { projects, count, loading, loadMoreProjects, groups, onGroupChange, currentGroupId, allGroupsWithAccess } = useUserProjects(userId);

  return (
    <>
      <div className="d-flex justify-content-between">
        <h2>
          {t('projects.title')} <small>({count})</small>
        </h2>
        {groups.length > 1 && (
          <div className="w-25">
            <Select
              options={groups}
              value={groups.find((gr) => gr.value === currentGroupId)}
              onChange={({ value }) => onGroupChange(value)}
            />
          </div>
        )}
      </div>
      <ProjectsTable
        projects={loading ? [] : projects!}
        loading={loading}
        count={count}
        onLoadMore={loadMoreProjects}
        hasMore={count > projects.length}
        allGroupsWithAccess={allGroupsWithAccess}
      />
    </>
  );
};
export default UserContainer;
